import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Store} from "@ngrx/store";
import {AppState} from "@store/state/app.state";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {
    ApiPaymentsSetRequest, ApiPaymentsSetResponse
} from "@api/payments";


@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    constructor(private http: HttpClient, private store: Store<AppState>, private environmentService: EnvironmentService) {
    }

    set(orderId: string, paymentProvider: 'paypal' | 'paypalExpress' | 'stripe' | 'stripeExpress' | 'klarna', externalPaymentId: string) {
        const body: ApiPaymentsSetRequest = {
            id: 'payments/set',
            command: 'payments/set',
            params: {
                data: {
                    orderId,
                    paymentProvider,
                    externalPaymentId
                }
            }
        };
        return this.http.post<ApiPaymentsSetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body))
    }

}
